import React, { HTMLAttributes } from 'react';
import { useMergedClassNames } from '../../utils/HTMLutils';
import './ThreeDotsLoader.scss';
const rootClassName = 'loader-three-dots';

export type ThreeDotsThemes = 'primary' | 'secondary' | 'dark';
export type ThreeDotsSizes = 1 | 2 | 3 | 4;
export interface ThreeDotsProps extends HTMLAttributes<HTMLDivElement> {
  theme?: ThreeDotsThemes;
  size?: 1 | 2 | 3 | 4;
}

export const ThreeDotsLoader = ({
  theme,
  size,
  className,
  ...rest
}: ThreeDotsProps) => {
  return (
    <div
      className={useMergedClassNames([
        rootClassName,
        className ?? '',
        `${rootClassName}-${theme ?? 'primary'}`,
        `${rootClassName}-size-${size ?? 3}`,
      ])}
      {...rest}
    >
      <div />
      <div />
      <div />
    </div>
  );
};
